import {Endpoints} from '../../../../../globals/api/endpoints';

export class BibliographyEndpoints extends Endpoints {

  private static readonly BIBLIOGRAPHY = BibliographyEndpoints.VIEWER + '/bibliography';
  public static readonly BIBLIOGRAPHY_ENTRY = BibliographyEndpoints.BIBLIOGRAPHY + '/' + BibliographyEndpoints.PROJECT_ID;
  public static readonly BIBLIOGRAPHY_ENTRY_PREVIEW = BibliographyEndpoints.BIBLIOGRAPHY + '/' + BibliographyEndpoints.VERSION_ID
    + '/preview';
}
